import { ChangeDetectionStrategy, Component, input, model, output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule, Table } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ITasksMap } from 'src/app/shared/models/tasks-planned';
import { TaskState } from 'src/app/shared/models/core';
import { MergeTaskStep } from '../merge-task-dialog.component';

@Component({
    selector: 'app-merge-task-table',
    standalone: true,
    imports: [CommonModule, FormsModule, TableModule, CheckboxModule, RadioButtonModule, TagModule, TooltipModule],
    templateUrl: './merge-task-table.component.html',
    styleUrls: ['./merge-task-table.component.scss', '../../../../../shared/css/primeng-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MergeTaskTableComponent {
  readonly routeName = input('');
  readonly tasks = input<ITasksMap[]>([]);
  readonly loading = input(false);
  readonly currentStep = input<MergeTaskStep | undefined>();
  readonly MergeTaskStep = input(MergeTaskStep);
  readonly selectionMode = input<'multiple' | 'single'>('multiple');
  readonly selectionChange = output<ITasksMap[]>();
  readonly selectionDisabled = input(false);
  readonly selectedTasks = model<any>();
  readonly selectionSummary = input<ITasksMap[]>([]);
  searchText = '';

  @ViewChild('taskTable') taskTable: Table;

  get selectedCount(): number {
    const selectedTasks = this.selectedTasks();
    if (Array.isArray(selectedTasks)) {
      return selectedTasks.length;
    }
    return selectedTasks ? 1 : 0;
  }

  onSelectionChange(): void {
    this.selectionChange.emit(this.selectedTasks());
  }

  onSearch(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.taskTable.filterGlobal(value, 'contains');
  }

  clearSearch(): void {
    this.searchText = '';
    this.taskTable.filterGlobal('', 'contains');
  }

  isValidForMerge(task: ITasksMap): boolean {
    return task.task_state !== TaskState.Completed && task.task_state !== TaskState.Failed;
  }

  get allValidForMerge(): boolean {
    return this.tasks().every(t => this.isValidForMerge(t));
  }

  get allSelectedValidForMerge(): boolean {
    const selectedTasks = this.selectedTasks();
    if (Array.isArray(selectedTasks)) {
      return selectedTasks.length > 0 && selectedTasks.every(t => this.isValidForMerge(t));
    }
    return selectedTasks ? this.isValidForMerge(selectedTasks) : false;
  }

  getTaskStateClass(state: string): string {
    switch (state?.toLowerCase()) {
      case 'planned': return 'primary-chip';
      case 'completed': return 'success-chip';
      case 'failed': return 'error-chip';
      case 'closed-merge': return 'error-chip';
      case 'unplanned': return 'warning-chip';
      case 'loaded': return 'warning-chip';
      default: return 'primary-chip';
    }
  }
}
